import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { ProductDataResponse, ProductPageControllerImpl, ProductPageFactoryImpl } from "../../../business";

export const ProductPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    const [isLoading, setLoading] = useState(true);
    const [productItemData, setProductItemData] = useState<ProductDataResponse>()
    const controller = new ProductPageControllerImpl();
    const factory = new ProductPageFactoryImpl();

    const fetchData = async (productUrl) => {
        try {
            const response = await controller.onLoad(productUrl);
            setLoading(false);
            setProductItemData(response);
        } catch (error) {
            console.error("Erro na requisição:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        id ? fetchData(id) : navigate('home');
    }, [id]);

    useEffect(() => {
        window.addEventListener(
            "resize",
            () => {
                const ismobile = window.innerWidth < 992;
                if (ismobile !== isMobile) setIsMobile(ismobile);
            },
            false
        );
    }, [isMobile]);
    return isLoading ? <Spinner animation="border" variant="primary" /> : factory.create(productItemData)
}
